module.exports = __webpack_public_path__ + "img/grey-academy-business.c3ff8828.png";